import React, {useEffect, useRef} from 'react';
import {MapContainer, Marker, Popup, TileLayer} from "react-leaflet";
import {LeafletMapTileUrl} from "@/constants/config";
import {redIcon} from "@/components/map/_section/icons";

function LockMap({point, zoom = 15, popupElement}) {
    const markerRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            markerRef.current?.openPopup();
        }, 100);

        return () => clearTimeout(timer);
    }, [point]);

    return (

        <MapContainer
            center={[point?.latitude, point?.longitude]}
            zoom={zoom}
            style={{height: "100%", width: "100%"}}
            dragging={false}
            touchZoom={false}
            doubleClickZoom={false}
            scrollWheelZoom={false}
            boxZoom={false}
            keyboard={false}
            zoomControl={false}
        >

            <TileLayer url={LeafletMapTileUrl()}></TileLayer>

            <Marker
                eventHandlers={{
                    add: (e) => {
                        e.target.openPopup();
                    },
                }}
                ref={markerRef}
                position={[point?.latitude, point?.longitude]} icon={redIcon}>

                {popupElement && (
                    <Popup
                        closeButton={false}
                        autoClose={false}
                        closeOnClick={false}
                    >
                        {React.cloneElement(popupElement, {item: point})}
                    </Popup>
                )}
            </Marker>
        </MapContainer>

    );
}

export default LockMap;